import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Cacheable, LocalStorageStrategy } from 'ts-cacheable';
import { CompanyData } from '../model/interface/company-data.interface';

@Injectable({
  providedIn: 'root'
})
export class InvoiceHttpService {
  constructor(private http: HttpClient) {}

  @Cacheable({
    storageStrategy: LocalStorageStrategy,
    maxAge: 3600000,
    shouldCacheDecider: (response) => {
      return Array.isArray(response) && response !== null && response.length > 0;
    }
  })
  getCompanyData(taxId: string): Observable<CompanyData> {
    return this.http.get<CompanyData>(`/company/${taxId}`);
  }
}
